export const ADMIN_AGENT_ASSISTANT_TYPE = { assistant_type: 'copilot' };

export const FAILED_THREAD_ID = 'error'; // A dummy thread ID to indicate that the thread failed to create
